import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {MARU_BATSU, TOUYO_HOUHOUS} from '../../constants';
import {SessionService} from '../../../core/service/session.service';
import {EventService} from '../../../core/service/event.service';
import {ShiyoulotService} from '../../../core/service/shiyoulot.service';
import {Mutable} from '../../typeAliases';
import {VaccineEvent} from '../../interfaces/vaccine-event';
import {VaccineJisshiNaiyou} from '../../interfaces/vaccine-jisshi-naiyou';
import {exceptKeyWithOptional, yyyyMMdd} from '../../typeAliases';

@Component({
  selector: 'app-vaccine-event-dialog',
  templateUrl: './vaccine-event-dialog.component.html',
  styleUrls: ['./vaccine-event-dialog.component.scss',
    './../../layout/layout.component.scss']
})
export class VaccineEventDialogComponent implements OnInit {
  selectedMeisais: VaccineEvent[] = [];
  inputForm: exceptKeyWithOptional<VaccineJisshiNaiyou, 'jisshiDate'> = this.getInitialVaccineJisshiNaiyou();
  touyoHouhous = TOUYO_HOUHOUS as Mutable<typeof TOUYO_HOUHOUS>;
  maruBatsu = MARU_BATSU;
  editEvent = false;
  edukeDate: yyyyMMdd;

  constructor(@Inject(MAT_DIALOG_DATA) public data: VaccineEvent[],
              public matDialogRef: MatDialogRef<VaccineEventDialogComponent>,
              public commonService: CommonService,
              public sessionService: SessionService,
              public shiyoulotService: ShiyoulotService,
              public eventService: EventService,) {
    this.edukeDate = this.data[0].taishouEdukeDate;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.selectedMeisais = this.data;
    this.eventService.setInputForm2(this.inputForm, this.selectedMeisais[0]);
    this.eventService.updateJisshiNichirei2(this.inputForm, this.edukeDate);
    if (this.selectedMeisais[0].touyoHouhou) {
      this.inputForm.touyoHouhou = this.selectedMeisais[0].touyoHouhou;
    }
  }

  /**
   * ワクチンイベント登録
   */
  register() {
    this.selectedMeisais.forEach((meisai: VaccineEvent) => {
      this.eventService.inputForm2Event2(this.inputForm, meisai);
    });
    console.log(this.selectedMeisais);
    this.eventService.updateEvents(this.selectedMeisais).then(() => {
      this.commonService.onClick(this.matDialogRef, true);
    }).catch();
  }

  /**
   * ワクチンイベント取り消し
   */
  undo() {
    if (confirm('実施内容を取り消しますか?')) {
      this.eventService.undoEvents(this.selectedMeisais).then(() => {
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }

  /**
   * ワクチンイベント削除
   */
  delete() {
    if (confirm('作業を削除しますか?')) {
      this.eventService.deleteEvents(this.selectedMeisais).then(() => {
        this.commonService.onClick(this.matDialogRef, true);
      }).catch();
    }
  }

  /**
   * ワクチン実施内容の初期値を返す
   */
  getInitialVaccineJisshiNaiyou(): exceptKeyWithOptional<VaccineJisshiNaiyou, 'jisshiDate'> {
    return {
      jisshiSha: this.sessionService.session.personalSetting.name,
      jisshiDate: this.commonService.getDateWithString(),
      jisshiNichirei: undefined,
      vaccineLotNumber: undefined,
      yuukouKigen: undefined,
      touyoHouhou: undefined,
      youkaiEki: undefined,
      dansuiHour: undefined,
      sesshuBui: undefined,
      isHattou: undefined,
      youkaiGoJikan: undefined,
      isWashedNyuukon: undefined,
      changeNeedleFrequency: undefined,
      isWashedPister: undefined,
      youkaiRyou: undefined
    };
  }
}
